mutation DeactivateCharityContact($input: DeactivateCharityContactInput!) {
  deactivateCharityContact(input: $input) {
    success
  }
}
